const destinations = [
  { flag: "🇬🇧", country: "United Kingdom", city: "London", desc: "SLU semester programs, agricultural trade shows, North Oaks physician CME conferences. Heathrow direct from MSY with connection.", popular: true },
  { flag: "🇩🇪", country: "Germany", city: "Frankfurt & Hamburg", desc: "Agricultural equipment trade shows and produce export markets. Tangipahoa Parish strawberry exporters travel for Fruit Logistica and Agritechnica.", popular: true },
  { flag: "🇲🇽", country: "Mexico", city: "Cancún & Mexico City", desc: "Most popular first international trip for Hammond families. Cancún all-inclusive resorts and Mexico City cultural tours are top picks.", popular: true },
  { flag: "🇨🇦", country: "Canada", city: "Toronto & Montreal", desc: "CME medical conferences at University of Toronto and McGill attract North Oaks and Tulane Medicine physicians from the Hammond region.", popular: false },
  { flag: "🇫🇷", country: "France", city: "Paris", desc: "SLU French studies program and Tangipahoa Parish's deep Cajun-French cultural connection make Paris a meaningful destination for Hammond students and families.", popular: false },
  { flag: "🇨🇷", country: "Costa Rica", city: "San José", desc: "Popular eco-tourism destination for Hammond-area families and SLU environmental science students on field research programs.", popular: false },
];

export default function HammondDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Where Hammond Travels</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Top International Destinations from Hammond
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From SLU study-abroad programs in Europe to agricultural trade missions and family vacations, here are the destinations we most frequently see Hammond and Tangipahoa Parish travelers visiting.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {destinations.map((d, i) => (
            <div key={i} className={`rounded-lg border p-5 flex flex-col hover:border-[#F6C344] transition-all ${d.popular ? "bg-[#F7F8FA] border-gray-200" : "bg-white border-gray-200"}`}>
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">{d.flag}</span>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{d.city}</p>
                  <p className="text-gray-400 text-xs">{d.country}</p>
                </div>
                {d.popular && <span className="ml-auto text-xs font-bold text-[#F6C344] bg-[#F6C344]/10 px-2 py-0.5 rounded-full whitespace-nowrap">Top Pick</span>}
              </div>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}